import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  OAuthAuthorizeConfirmResponse,
  OAuthAuthorizePreview,
  OAuthConsentParams,
} from '../models/oauth-consent.model';

@Injectable({ providedIn: 'root' })
export class OAuthConsentService {
  #http = inject(HttpClient);

  preview(params: OAuthConsentParams): Promise<OAuthAuthorizePreview> {
    let httpParams = new HttpParams()
      .set('client_id', params.clientId)
      .set('redirect_uri', params.redirectUri)
      .set('scope', params.scope)
      .set('code_challenge', params.codeChallenge);

    if (params.codeChallengeMethod?.trim()) {
      httpParams = httpParams.set(
        'code_challenge_method',
        params.codeChallengeMethod.trim(),
      );
    }
    if (params.state?.trim()) {
      httpParams = httpParams.set('state', params.state.trim());
    }

    return firstValueFrom(
      this.#http.get<OAuthAuthorizePreview>(
        `${environment.baseUrl}/user/oauth/authorize/preview`,
        { params: httpParams },
      ),
    );
  }

  confirm(params: OAuthConsentParams): Promise<OAuthAuthorizeConfirmResponse> {
    return firstValueFrom(
      this.#http.post<OAuthAuthorizeConfirmResponse>(
        `${environment.baseUrl}/user/oauth/authorize/confirm`,
        {
          client_id: params.clientId,
          redirect_uri: params.redirectUri,
          scope: params.scope,
          code_challenge: params.codeChallenge,
          code_challenge_method: params.codeChallengeMethod?.trim() || 'S256',
          state: params.state?.trim() || undefined,
        },
      ),
    );
  }
}
